export {defaultGetServerSideProps as getServerSideProps} from 'utils/server/defaultGetServerSideProps'

import {useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import {TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY} from '@vio/core/src/auth/modules/actions'

const RedirectToSearch = () => {
  const dispatch = useDispatch()
  const {brandSiteAddress} = useBrand()

  useEffect(() => {
    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.Page,
        action: Action.Errored,
        payload: {
          errorMessage: 'Page not found'
        }
      })
    )
    if (process.env.NEXT_PUBLIC_ENV === 'production' && brandSiteAddress) {
      // Add a small timeout before redirect to make sure that event is sent
      setTimeout(() => {
        window.location.replace(brandSiteAddress)
      }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY)
    }
  }, [brandSiteAddress])

  return null
}
export default RedirectToSearch
